<template>
  <div class="inspection-tour-history-detail">
    <div class="classroom-detail">
      <div class="classroom-info">
        <a-icon type="left" @click="backListRouter" style="fontsize: 20px" />
        <img src="../../../assets/img/building_img.png" alt="" />
        <div class="classroom-name">
          <div class="name text-overflow-one" :title="showDomTitle ? classroomInfo.roomName : undefined">
            {{ classroomInfo.roomName }}
          </div>
          <div class="building-name">{{ classroomInfo.buildingName }}</div>
        </div>
      </div>
      <div class="tour-info">
        <div class="tour-count">
          巡视次数&ensp;
          <span class="unit inspection-num">{{ classroomInfo.inspectionNumber }}</span>
          <span>次</span>
        </div>
        <div class="current-inspection">
          最近巡视
          <span class="unit">{{ classroomInfo.lastInspectionTime || '--' }}</span>
        </div>
      </div>
    </div>
    <div class="detail-content">
      <div class="top-filter">
        <a-range-picker
          :placeholder="rangePicker"
          :format="dateFormat"
          separator="至"
          @change="onChange"
          v-model="momentDate"
        >
          <a-icon slot="suffixIcon" type="calendar" />
        </a-range-picker>
        <div class="right">
          <a-button type="primary" class="primary-btn" @click="openTourdetailDailog()">巡视备注</a-button>
          <a-input-search v-model="keywords" placeholder="请输入课程关键字" style="width: 200px" @search="onSearch" />
        </div>
      </div>
      <div class="table-content">
        <a-table
          @change="tableChangeEvent"
          :columns="columns"
          :data-source="classroomTourList"
          :pagination="false"
          :row-key="(record, index) => index"
          :loading="loading"
        >
          <span slot="inspectionDate" slot-scope="text, record">
            <span>{{ record.inspectionDate || '--' }}</span>
          </span>
          <!-- <span slot="action" slot-scope="text, record">
            <span style="cursor: pointer; color: #1572FF" @click="openTourdetailDailog(record)">备注详情</span>
          </span> -->
        </a-table>
        <a-row type="flex" justify="end" style="margin-top: 20px">
          <a-pagination
            show-size-changer
            :default-current="1"
            :page-size-options="pageSizeOptions"
            :total="pagination.total"
            :defaultPageSize="50"
            @change="handlePageChange"
            @showSizeChange="onShowSizeChange"
            v-model="pagination.current"
            :pageSize.sync="pagination.pageSize"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </div>
    </div>
    <BackupDialogVue
      :showDialog="showTourDetailDialog"
      :defaultBackup="tourInfo"
      :classroomCodeProp="classroomCode"
      @setBackupDialog="setBackupDialog"
    />
  </div>
</template>

<script>
import BackupDialogVue from '../HistoricalReplay/comp/BackupDialog.vue'
import DateUtil from '../../../utils/getDate.js'

const columns = [
  {
    title: '教室',
    dataIndex: 'roomName',
    key: 'roomName',
    scopedSlots: { customRender: 'roomName' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '教室状态',
    dataIndex: 'roomStatus',
    key: 'roomStatus',
    scopedSlots: { customRender: 'roomStatus' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '课程名称',
    dataIndex: 'liveName',
    key: 'liveName',
    scopedSlots: { customRender: 'liveName' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '老师',
    dataIndex: 'teachName',
    key: 'teachName',
    scopedSlots: { customRender: 'teachName' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '巡视人',
    dataIndex: 'inspectionPeopleName',
    key: 'inspectionPeopleName',
    scopedSlots: { customRender: 'inspectionPeopleName' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '巡视时间',
    dataIndex: 'inspectionDate',
    key: 'inspectionDate',
    scopedSlots: { customRender: 'inspectionDate' },
    ellipsis: true,
    align: 'left'
  }
  // {
  //   title: '操作',
  //   dataIndex: 'id',
  //   key: 'action',
  //   scopedSlots: { customRender: 'action' },
  //   ellipsis: true,
  //   class: 'action',
  //   align: 'center',
  // },
]
export default {
  name: 'InspectionTourHistoryDetail',
  components: { BackupDialogVue },
  // created() {
  // },
  activated() {
    console.log('detail-activated')
    this.classroomInfo = this.$route.params.detailInfo
      ? this.$route.params.detailInfo
      : JSON.parse(localStorage.getItem('classroomInfo'))
    this.classroomCode = this.$route.classroomCode || this.classroomInfo.classroomCode
    this.momentDate = []
    this.startTime = ''
    this.endTime = ''
    this.pagination.current = 1
    this.keywords = ''
    this.getCalssroonTourList()
  },
  data() {
    return {
      columns,
      detailListData: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0
      },
      pageSizeOptions: ['50', '100', '150', '200'],
      loading: false,
      classroomInfo: {},
      classroomCode: '',
      classroomTourList: [],
      showTourDetailDialog: false,
      tourInfo: '',
      keywords: '',
      startTime: '',
      endTime: '',
      rangePicker: ['巡视开始时间', '巡视结束时间'],
      dateFormat: 'YYYY-MM-DD',
      momentDate: [],
      showDomTitle: false
    }
  },
  methods: {
    onChange(value) {
      this.momentDate = value
      if (value && value.length) {
        this.startTime = DateUtil.formatDate(value[0]._d)
        this.endTime = DateUtil.formatDate(value[1]._d)
      } else {
        this.startTime = ''
        this.endTime = ''
      }
      this.pagination.current = 1
      this.getCalssroonTourList()
    },
    onSearch(value) {
      console.log(value)
      this.pagination.current = 1
      this.getCalssroonTourList()
    },
    tableChangeEvent(pagination) {
      this.pagination.current = pagination.current
      this.getCalssroonTourList()
    },
    backListRouter() {
      this.$router.push({
        name: 'InspectionTourHistory'
      })
    },
    async getCalssroonTourList() {
      const res = await this.$http.getClassroomHistoryList({
        classroomCode: this.classroomCode,
        endTime: this.endTime,
        startTime: this.startTime,
        keywords: this.keywords,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      if (res.code === 200 && res.rt.resultStatus === 1) {
        // console.log('res🐶:>>>>>>>', res.rt, 'src/views/ClassroomInspectionTour/InspectionTourHistoryDetail/index.vue')
        this.classroomTourList = res.rt.list || []
        this.pagination.total = res.rt.totalCount
      }
    },
    openTourdetailDailog() {
      this.getTourInfo()
      this.showTourDetailDialog = true
    },
    async getTourInfo() {
      const info = await this.$http.getExtendInfo({
        classroomCode: this.classroomCode
      })
      if (info.code === 200 && info.rt) {
        this.tourInfo = info.rt.notes || ''
      }
    },
    setBackupDialog(data) {
      this.showTourDetailDialog = data.showBackupDialog
    },
    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getCalssroonTourList()
    },
    onShowSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getCalssroonTourList()
    },
    handleMouseEnter(id) {
      const currentDom = document.getElementsByClassName(`name`)
      let textWidth = currentDom[0].scrollWidth || 0
      let domWidth = currentDom[0].clientWidth || 0
      if (textWidth > domWidth) {
        this.showDomTitle = true
      } else {
        this.showDomTitle = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.classroom-detail {
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 14px;
  color: #1e2228;
  background: #fff;
  .classroom-info {
    display: flex;
    align-items: center;
    // width: calc(100% - 320px - 10px);
    width: auto;
    img {
      margin-left: 35px;
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
  }
  .classroom-name {
    display: flex;
    text-align: left;
    flex-direction: column;
    margin-left: 32px;
    max-width: calc(100% - 120px);
    .name {
      margin-bottom: 4px;
      font-size: 28px;
      font-weight: 500;
    }
  }
  .tour-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    // width: 320px;
    width: auto;
    .tour-count {
      display: flex;
      align-items: center;
      // vertical-align: center;
    }
    .current-inspection {
      margin-left: 60px;
    }
  }
}
.detail-content {
  margin-top: 16px;
  min-height: calc(100vh - 110px - 40px - 16px - 56px);
  padding: 16px;
  background: #fff;
  .top-filter {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select-school {
      margin-right: 10px;
    }
    ::v-deep .ant-calendar-picker {
      width: 280px !important;
    }
    .primary-btn {
      margin-right: 20px;
      height: 32px;
      line-height: 32px;
      border-color: #5f60d3;
      background-color: #5f60d3;
    }
  }
  .table-content {
    margin-top: 16px;
  }
}
.unit {
  font-family:
    PingFangSC-Semibold,
    PingFang SC;
  font-weight: 600;
  color: #5f60d3;
}
.inspection-num {
  font-size: 28px;
  line-height: 28px;
  margin-right: 4px;
}
</style>
